import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store/index';

import { ProductCategory } from './product-category';
export class ProductCategoriesActions {

  static LOAD_PRODUCT_CATEGORIES = '[ProductCategories] Load Product Categories';
/**
 * @return {?}
 */
public loadProductCategories(): Action {
    return {
      type: ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES
    };
  }

  static LOAD_PRODUCT_CATEGORIES_SUCCESS = '[ProductCategories] Load Product Categories Success';
/**
 * @param {?} productCategories
 * @return {?}
 */
loadProductCategoriesSuccess(productCategories: ProductCategory[]): Action {
    return {
      type: ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES_SUCCESS,
      payload: productCategories
    };
  }

  static ADD_PRODUCT_CATEGORY = '[ProductCategories] Add Product Category';
/**
 * @param {?} productCategory
 * @return {?}
 */
addProductCategory(productCategory: ProductCategory): Action {
    return {
      type: ProductCategoriesActions.ADD_PRODUCT_CATEGORY,
      payload: productCategory
    };
  }

  static ADD_PRODUCT_CATEGORY_SUCCESS = '[ProductCategories] Add Product Category Success';
/**
 * @param {?} productCategory
 * @return {?}
 */
addProductCategorySuccess(productCategory: ProductCategory): Action {
    return {
      type: ProductCategoriesActions.ADD_PRODUCT_CATEGORY_SUCCESS,
      payload: productCategory
    };
  }

  static DELETE_PRODUCT_CATEGORY = '[ProductCategories] Delete Product Category';
/**
 * @param {?} productCategoryName
 * @return {?}
 */
deleteProductCategory(productCategoryName: string): Action {
    return {
      type: ProductCategoriesActions.DELETE_PRODUCT_CATEGORY,
      payload: productCategoryName
    };
  }

  static DELETE_PRODUCT_CATEGORY_SUCCESS = '[ProductCategories] Delete Product Category Success';
/**
 * @param {?} res
 * @return {?}
 */
deleteProductCategorySuccess(res: any): Action {
    return {
      type: ProductCategoriesActions.DELETE_PRODUCT_CATEGORY_SUCCESS,
      payload: res
    };
  }

  static MOVE_PRODUCT_CATEGORY_TO = '[ProductCategories] Move Product Category To';
/**
 * @param {?} productCategoryName
 * @param {?} displayIndex
 * @return {?}
 */
moveProductCategoryTo(productCategoryName: string, displayIndex: number): Action {
    return {
      type: ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO,
      payload: {
        productCategoryName: productCategoryName,
        displayIndex: displayIndex
      }
    };
  }

  static MOVE_PRODUCT_CATEGORY_TO_SUCCESS = '[ProductCategories] Move Product Category To Success';
/**
 * @param {?} res
 * @return {?}
 */
moveProductCategoryToSuccess(res: any): Action {
    return {
      type: ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO_SUCCESS,
      payload: res
    };
  }

  static GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE = '[ProductCategories] Get Product Category Image Signature';
/**
 * @param {?} productCategory
 * @param {?} file
 * @param {?} fileName
 * @return {?}
 */
getProductCategoryImageSignature(productCategory: ProductCategory, file: any, fileName: string): Action {
    return {
      type: ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE,
      payload: {
        ProductCategory: productCategory,
        File: file,
        FileName: fileName
      }
    };
  }

  static GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE_SUCCESS = '[ProductCategories] Get Product Category Image Signature Success';
/**
 * @param {?} payload
 * @return {?}
 */
getProductCategoryImageSignatureSuccess(payload: {response: any, File: any, ProductCategory: ProductCategory}): Action {
    return {
      type: ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE_SUCCESS,
      payload: payload
    };
  }
  
    static UPDATE_PRODUCT_CATEGORY_IMAGE = '[ProductCategories] Update Product Category Image';
/**
 * @param {?} productCategory
 * @param {?} imageUrl
 * @return {?}
 */
updateProductCategoryImage(productCategory: ProductCategory, imageUrl: string): Action {
      return {
        type: ProductCategoriesActions.UPDATE_PRODUCT_CATEGORY_IMAGE,
        payload: {
          ProductCategory: productCategory,
          ImageUrl: imageUrl
        }
      };
    }
  
    static UPDATE_PRODUCT_CATEGORY_IMAGE_SUCCESS = '[ProductCategories] Update Product Category Image Success';
/**
 * @param {?} res
 * @return {?}
 */
updateProductCategoryImageSuccess(res:any): Action {
      return {
        type: ProductCategoriesActions.UPDATE_PRODUCT_CATEGORY_IMAGE_SUCCESS,
        payload: res
      };
    }

  static ADD_PRODUCT_CATEGORY_IMAGE_SUCCESS = '[ProductCategories] Add Product Category Image Success';
/**
 * @param {?} res
 * @return {?}
 */
addProductCategoryImageSuccess(res: any): Action {
    return {
      type: ProductCategoriesActions.ADD_PRODUCT_CATEGORY_IMAGE_SUCCESS,
      payload: res
    };
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProductCategoriesActions_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES;
/** @type {?} */
ProductCategoriesActions.LOAD_PRODUCT_CATEGORIES_SUCCESS;
/** @type {?} */
ProductCategoriesActions.ADD_PRODUCT_CATEGORY;
/** @type {?} */
ProductCategoriesActions.ADD_PRODUCT_CATEGORY_SUCCESS;
/** @type {?} */
ProductCategoriesActions.DELETE_PRODUCT_CATEGORY;
/** @type {?} */
ProductCategoriesActions.DELETE_PRODUCT_CATEGORY_SUCCESS;
/** @type {?} */
ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO;
/** @type {?} */
ProductCategoriesActions.MOVE_PRODUCT_CATEGORY_TO_SUCCESS;
/** @type {?} */
ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE;
/** @type {?} */
ProductCategoriesActions.GET_PRODUCT_CATEGORY_IMAGE_SIGNATURE_SUCCESS;
/** @type {?} */
ProductCategoriesActions.UPDATE_PRODUCT_CATEGORY_IMAGE;
/** @type {?} */
ProductCategoriesActions.UPDATE_PRODUCT_CATEGORY_IMAGE_SUCCESS;
/** @type {?} */
ProductCategoriesActions.ADD_PRODUCT_CATEGORY_IMAGE_SUCCESS;
/** @type {?} */
ProductCategoriesActions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductCategoriesActions.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
